import { Trans } from 'react-i18next'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { ComponentSettingKey } from '@/shared/builder'

import { CompGalleryWrapperCore } from '../core/gallery/wrapper'

const CompGalleryWrapper = () => {
  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // action
  const actionContext = useBuilderActionContextV2()

  // tableData
  const { dbClient, language, userSpecific, tablesMap } = useDbClientContext()
  const tableId = compContext.settings[ComponentSettingKey.GalleryDataSource]
  const table = tableId ? tablesMap.get(tableId) : undefined

  // todo: error state
  if (!table || !dbClient) {
    return (
      <div className='flex justify-center items-center py-8'>
        <Trans>COMP_TABLE_NOT_FOUND</Trans>
      </div>
    )
  }

  return (
    <CompGalleryWrapperCore
      infos={infosProps}
      action={actionContext}
      tableData={{ dbTable: table, dbClient, tableId, language, userSpecific }}
    />
  )
}

export default CompGalleryWrapper
